"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListContainer = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var classNames = require("classnames");
var recompose_1 = require("recompose");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var memoize = require("fast-memoize");
var moment = require("moment");
var ColumnFilter_1 = require("components/ColumnFilter");
var components_1 = require("components");
var sok_ui_1 = require("@caddigital/sok-ui");
var FilesActions = require("@caddigital/sok-reducers/lib/actions/congrid/files");
var files_1 = require("@caddigital/sok-reducers/lib/reducers/congrid/files");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var translate_1 = require("utils/translate");
var Types = require("types");
var viewport_1 = require("reducers/viewport");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var text_1 = require("utils/text");
var search_1 = require("utils/search");
var avatars_1 = require("components/Avatar/avatars");
var ListRow_1 = require("views/FileListOverview/FileList/ListRow");
var preview_1 = require("utils/preview");
var FileListLink_1 = require("components/FileListLink/FileListLink");
var SortButton = sok_ui_1.Table.SortButton;
var headers = [
    'name-meta',
    'description-meta',
    'added-meta',
    'detele'
];
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        token: state.auth.current.token,
        list: state.congrid.files,
        metas: state.files.metadata,
        isMobile: (0, viewport_1.isMobile)(state.viewport),
        selectedLanguage: selectedLanguage
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetch: function (project) {
        return dispatch(FilesActions.fetchRequest(project.id));
    },
    remove: function (project, file) {
        return dispatch(FilesActions.removeRequest(project, file));
    }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
function getFilteredData(list, filters) {
    var keys = Object.keys(filters);
    if (keys.length === 0) {
        return list;
    }
    var filtered = list.reduce(function (result, item) {
        var _loop_1 = function (i) {
            var key = keys[i];
            switch (key) {
                case 'name-meta':
                case 'description-meta': {
                    var searchValue = filters[key];
                    var meta = item.customMeta && item.customMeta.find(function (x) { return x.uuid === key; });
                    if (searchValue &&
                        meta &&
                        meta.value &&
                        meta.value
                            .toString()
                            .toLowerCase()
                            .indexOf(searchValue.toLowerCase()) === -1) {
                        return { value: result };
                    }
                    break;
                }
                case 'added-meta': {
                    var searchValue = filters[key];
                    var meta = item.customMeta && item.customMeta.find(function (x) { return x.uuid === key; });
                    if (searchValue &&
                        meta &&
                        meta.value &&
                        moment(parseInt(meta.value.toString(), 10))
                            .format('l')
                            .toString()
                            .toLowerCase()
                            .indexOf(searchValue.toLowerCase()) === -1) {
                        return { value: result };
                    }
                    break;
                }
                default: {
                    var searchValue = filters[key];
                    var value = item.name;
                    if (searchValue &&
                        value &&
                        value
                            .toString()
                            .toLowerCase()
                            .indexOf(searchValue.toLowerCase()) === -1) {
                        return { value: result };
                    }
                }
            }
        };
        for (var i = 0; i < keys.length; i++) {
            var state_1 = _loop_1(i);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        result.push(item);
        return result;
    }, []);
    return filtered;
}
function sortFiles(orderByOptions) {
    var order = orderByOptions.order, orderBy = orderByOptions.orderBy;
    var column = orderBy;
    return function (a, b) {
        if (orderBy === 'name-meta') {
            return order === 'desc'
                ? b.name.localeCompare(a.name)
                : a.name.localeCompare(b.name);
        }
        if (!a.customMeta && !b.customMeta) {
            return 0;
        }
        if (!a.customMeta) {
            return -1;
        }
        if (!b.customMeta) {
            return 1;
        }
        var al = a.customMeta.reduce(function (p, curr) {
            p[curr.identifier] = curr.value;
            return p;
        }, {});
        var bl = b.customMeta.reduce(function (p, curr) {
            p[curr.identifier] = curr.value;
            return p;
        }, {});
        // if no column to make comparision against, compare using the name
        if (!al[column] && !bl[column]) {
            return a.name.localeCompare(b.name);
        }
        if (al[column] === null) {
            return 1;
        }
        if (bl[column] === null) {
            return -1;
        }
        return al[column] < bl[column]
            ? order === 'asc'
                ? 1
                : -1
            : order === 'asc'
                ? -1
                : 1;
    };
}
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.withState)('total', 'setTotal', 0), (0, recompose_1.withState)('items', 'setItems', []), (0, recompose_1.withState)('orderByOptions', 'setOrderByOptions', __assign({}, files_1.defaultOrderByOptions)), (0, recompose_1.withState)('filterOptions', 'setFilterOptions', {}), (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        var _a = this.props.queryParams, project = _a.project, orderBy = _a.orderBy, order = _a.order, filters = __rest(_a, ["project", "orderBy", "order"]);
        this.props.setOrderByOptions({
            order: order || files_1.defaultOrderByOptions.order,
            orderBy: orderBy || files_1.defaultOrderByOptions.orderBy
        });
        this.props.setFilterOptions(filters);
    },
    componentDidUpdate: function (prevProps) {
        var _this = this;
        var orderByOptions = this.props.orderByOptions;
        var filterOptions = this.props.filterOptions;
        if (this.props.queryParams !== prevProps.queryParams) {
            var _a = this.props.queryParams, project = _a.project, orderBy = _a.orderBy, order = _a.order, filters = __rest(_a, ["project", "orderBy", "order"]);
            var opts = {
                order: order || files_1.defaultOrderByOptions.order,
                orderBy: orderBy || files_1.defaultOrderByOptions.orderBy
            };
            this.props.setOrderByOptions(opts);
            orderByOptions = opts;
            this.props.setFilterOptions(filters);
            filterOptions = filters;
        }
        var items = this.props.list.items;
        if (orderByOptions !== prevProps.orderByOptions ||
            filterOptions !== prevProps.filterOptions ||
            (prevProps.list.items.length === 0 && this.props.list.items.length) ||
            this.props.list.items !== prevProps.list.items ||
            (prevProps.list.status !== 'FETCHED' &&
                this.props.list.status === 'FETCHED')) {
            var list = this.props.list;
            var data = getFilteredData(list.items, filterOptions).sort(sortFiles(orderByOptions));
            items = data;
            this.props.setItems(items);
        }
        if (this.props.list.items !== prevProps.list.items) {
            var contentWidth_1 = 0;
            // Handle files
            var columns_1 = this.props.list.items.reduce(function (p, item) {
                var name = item.name;
                var description = item.customMeta &&
                    item.customMeta.find(function (x) { return x.uuid === 'description-meta'; });
                var added = item.customMeta &&
                    item.customMeta.find(function (x) { return x.uuid === 'added-meta'; });
                var nameLength = (0, text_1.calculateStringLength)(name);
                var descriptionLength = (0, text_1.calculateStringLength)(description && description.value
                    ? description.value.toString()
                    : '');
                var addedLength = (0, text_1.calculateStringLength)(added && added.value
                    ? moment(parseInt(added.value.toString(), 10)).format('l')
                    : '');
                if ((p['__namemeta'] || 0) < nameLength) {
                    p['__namemeta'] = nameLength;
                }
                if ((p['__descriptionmeta'] || 0) < descriptionLength) {
                    p['__descriptionmeta'] = descriptionLength;
                }
                if ((p['__addedmeta'] || 0) < addedLength) {
                    p['__addedmeta'] = addedLength;
                }
                return p;
            }, {});
            // Handle metas
            this.props.projectMetadata.forEach(function (x) {
                if (_this.props.isMobile) {
                    if (x.identifier !== 'name-meta') {
                        return;
                    }
                }
                else {
                    if (!headers.includes(x.identifier)) {
                        return;
                    }
                }
                var dataKey = '__' + x.identifier.replace(/-/g, '');
                var length = (0, text_1.calculateStringLength)(x.name) + 42;
                var prevValue = columns_1[dataKey];
                if (prevValue && prevValue < length) {
                    columns_1[dataKey] = length;
                }
                else if (!prevValue) {
                    columns_1[dataKey] = length;
                }
            });
            // Delete button
            var deleteText = (0, translation_1.getLocalization)("buttons/delete").toString();
            columns_1['__delete'] = Math.max((0, text_1.calculateStringLength)(deleteText), 26);
            // Create styles
            var lengths_1 = Object.keys(columns_1).reduce(function (prev, x) {
                prev[x] = columns_1[x];
                return prev;
            }, {});
            // Override styles for dynamic classes
            var style = document.getElementById('CongridFileListCSS');
            if (style && style.parentNode) {
                style.parentNode.removeChild(style);
            }
            style = document.createElement('style');
            style.id = 'CongridFileListCSS';
            document.head && document.head.appendChild(style);
            var sheet_1 = style.sheet;
            contentWidth_1 += 2 * 13;
            Object.keys(lengths_1).forEach(function (className, i) {
                var colwidth = Math.max(8, 4 + lengths_1[className] + 26); // convert to rem
                contentWidth_1 += colwidth;
                sheet_1.insertRule(".".concat(className) +
                    ' {max-width: ' +
                    colwidth +
                    'px;\n min-width: ' +
                    colwidth +
                    'px;}', i);
            });
            this.props.setContentWidth(contentWidth_1);
        }
    }
}), recompose_1.pure);
function getColumn(column, value) {
    return (React.createElement("div", { className: classNames("row__column dynamic __".concat(column), column === 'name-meta' && 'expand'), "data-key": "__".concat(column) }, value));
}
function getHeaderColumn(props, meta) {
    if (!meta) {
        return React.createElement("div", null);
    }
    var order = props.orderByOptions.orderBy === meta.identifier &&
        props.orderByOptions.order === 'asc'
        ? 'desc'
        : 'asc';
    var enabled = true;
    var dataKey = '__' + meta.identifier.replace(/-/g, '');
    return (React.createElement("div", { key: meta.identifier, "data-key": dataKey, "data-length": meta.name.length, className: classNames('row__column dynamic congrid-list-row-column', dataKey) },
        React.createElement("div", { onClick: function () {
                var params = __assign(__assign({}, props.queryParams), { order: order, orderBy: meta.identifier });
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            } }, meta.name),
        React.createElement(SortButton, { className: "d-none d-desktop-table-cell filter", order: props.orderByOptions.orderBy === meta.identifier
                ? props.orderByOptions.order.toLowerCase()
                : null, disabled: !enabled, onChange: function () {
                var params = __assign(__assign({}, props.queryParams), { order: order, orderBy: meta.identifier });
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            } }),
        React.createElement(ColumnFilter_1.ColumnFilter, { className: props.filterOptions && props.filterOptions[meta.identifier]
                ? 'active'
                : '' + ' filter', columnIdentifier: meta.identifier, textInputValue: props.filterOptions && props.filterOptions[meta.identifier]
                ? props.filterOptions[meta.identifier] || ''
                : '', inputType: meta.type, setColumnFilterString: function (field, value) {
                var params = __assign({}, props.queryParams);
                params[field] = value;
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            }, clearColumnFilter: function (field) {
                var params = __assign({}, props.queryParams);
                params[field] = undefined;
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            } })));
}
var NotFoundPlaceHolder = function (props) { return (React.createElement("div", __assign({}, props, { key: 'no-files', className: 'no-congrid-files' }),
    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_9'), width: 200, height: 200 }),
    React.createElement("b", null, (0, translation_1.getLocalization)("congrid/list/emptyList/title")),
    React.createElement("span", null, (0, translation_1.getLocalization)("congrid/list/emptyList/message")))); };
var Header = function (props) {
    var name = props.projectMetadata.find(function (x) { return x.identifier === 'name-meta'; });
    var description = props.projectMetadata.find(function (x) { return x.identifier === 'description-meta'; });
    var added = props.projectMetadata.find(function (x) { return x.identifier === 'added-meta'; });
    return (React.createElement("div", { className: 'header row', style: props.style },
        React.createElement("div", { className: "row__column narrow" }),
        getHeaderColumn(props, name),
        getHeaderColumn(props, description),
        getHeaderColumn(props, added),
        React.createElement("div", { className: "row__column __delete" }, (0, translation_1.getLocalization)("buttons/delete")),
        React.createElement("div", { className: "row__column narrow" })));
};
var _createRowData = function (style, isMobile, items, selectedLanguage, token, remove, selectedProject, currentProject) { return ({
    style: style,
    isMobile: isMobile,
    items: items,
    currentProject: currentProject,
    selectedProject: selectedProject,
    selectedLanguage: selectedLanguage,
    remove: remove,
    token: token
}); };
var createRowData = memoize(_createRowData);
var ListRowDataExtractable = Types.extractReturnType(_createRowData);
var ListRow = React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var isMobile = data.isMobile, items = data.items, currentProject = data.currentProject, selectedLanguage = data.selectedLanguage, token = data.token, selectedProject = data.selectedProject, remove = data.remove;
    var row = items[index];
    var cm = row.customMeta || [];
    var description = cm.find(function (x) { return x.identifier === 'description-meta'; });
    var added = cm.find(function (x) { return x.identifier === 'added-meta'; });
    var link = (0, preview_1.createLink)(row, "/".concat(selectedLanguage, "/projects/").concat(currentProject.id, "/files/").concat(row.parent), isMobile, token);
    var target = (0, ListRow_1.getTarget)(row, isMobile);
    return (React.createElement("div", { className: classNames('row'), style: style },
        React.createElement("div", { className: "row__column narrow" }),
        getColumn('namemeta', React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, row.path) },
            React.createElement(FileListLink_1.FileListLink, { file: row, link: link, isMobile: isMobile, target: target || '' }))),
        getColumn('descriptionmeta', (description && description.value) || '-'),
        getColumn('addedmeta', (added && moment(parseInt(added.value.toString(), 10)).format('l')) ||
            '-'),
        React.createElement("div", { className: "row__column __delete" },
            React.createElement(components_1.TableRowIcon, { className: 'red', circle: true, icon: 'fa-times', onClick: function () { return selectedProject && remove(selectedProject, row); } })),
        React.createElement("div", { className: "row__column narrow" })));
});
exports.ListContainer = enhance(function (props) {
    // memoize item props into props.data object
    var itemData = createRowData({}, props.isMobile, props.items, props.selectedLanguage, props.token, props.remove, props.selectedProject, props.currentProject);
    return (React.createElement(React.Fragment, null,
        React.createElement(sok_ui_1.RequestStatusBox, { key: 'status-box', status: props.list.removeStatus, statusList: ['STANDBY', 'FETCHING', 'FETCHED', 'FAILED'] },
            (0, translation_1.getLocalization)('congrid/files/remove/fetching'),
            (0, translation_1.getLocalization)('congrid/files/remove/fetched'),
            (0, translation_1.getLocalization)('congrid/files/remove/failed')),
        React.createElement("div", { key: 'list', className: 'sok-list-content congrid-files-list ' +
                props.list.status.toLowerCase() },
            props.list.status === 'FAILED' && (React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('generic/error') },
                React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () {
                        return props.selectedProject && props.fetch(props.selectedProject);
                    } }))),
            props.list.status === 'FETCHING' && (React.createElement("div", { key: 'loading', className: 'center' },
                React.createElement(sok_ui_1.LoadingSpinner, null))),
            props.list.status === 'FETCHED' && props.items && (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                var width = _a.width, height = _a.height;
                return (React.createElement(sok_ui_1.List, { key: 'list', itemCount: props.items.length, itemData: itemData, overscanCount: 8, width: width, height: height, itemHeight: 50, itemWidth: props.contentWidth, header: React.createElement(Header, __assign({ key: 'header' }, props)), placeholder: React.createElement(NotFoundPlaceHolder, { key: 'not-found' }) }, ListRow));
            })))));
});
